import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TokenManager } from './tokenManager';
import { environment } from '../../environments/environment';
import { LensCatalogReferenceType, LensMaterialReferenceType } from './data/lens-catalog-api-item';

@Injectable()
export class LensCatalogApiService {

  LENS_VISION_TYPES = 'lensvisiontypes';
  LENS_DETAIL = 'spectaclelenses';
  LENS_MATERIAL_TYPES = 'lensmaterialtypes';
  AR_COATINGS = 'labservices/arcoatings';
  SCRATCH_COATINGS = 'labservices/scratchcoatings';
  UV_COATINGS = 'labservices/miscellaneousservices/uvcoatings';
  MIRROR_SKI_COATINGS = 'labservices/miscellaneousservices/mirrorskicoatings';
  GLASS_COATINGS = 'labservices/miscellaneousservices/glasscoatings';
  LENS_SUMMARIES = 'spectaclelenses/summaries';
  TINT_COLORS = 'labservices/miscellaneousservices/tintcolors';
  EDGES = 'labservices/miscellaneousservices/edges';
  TINT_TYPES = 'labservices/miscellaneousservices/tinttypes';
  BEVEL = 'labservices/miscellaneousservices/bevel';
  MISC = 'labservices/miscellaneousservices/miscellaneous';

  lensCatalogApiEndpoint: string = environment.lensCatalogApiEndpoint;

  constructor(private http: HttpClient, private tokenManager: TokenManager) {
  }

  getVisionTypes() {
    return this.callLensCatalog(this.LENS_VISION_TYPES);
  }

  getMaterialTypes() {
    return this.callLensCatalog(this.LENS_MATERIAL_TYPES);
  }

  getArCoatings() {
    return this.callLensCatalog(this.AR_COATINGS);
  }

  getScratchCoatings() {
    return this.callLensCatalog(this.SCRATCH_COATINGS);
  }

  getUvCoatings() {
    return this.callLensCatalog(this.UV_COATINGS);
  }

  getMirrorSkiCoatings() {
    return this.callLensCatalog(this.MIRROR_SKI_COATINGS);
  }

  getGlassCoatings() {
    return this.callLensCatalog(this.GLASS_COATINGS);
  }

  getTintColors() {
    return this.callLensCatalog(this.TINT_COLORS);
  }

  getTintTypes() {
    return this.callLensCatalog(this.TINT_TYPES);
  }

  getEdges() {
    return this.callLensCatalog(this.EDGES);
  }

  getBevel() {
    return this.callLensCatalog(this.BEVEL);
  }

  getMiscellaneous() {
    return this.callLensCatalog(this.MISC);
  }

  getLenses(channelName: string, visionType: string, materialType: string, dateOfService: string) {
    const url = this.LENS_SUMMARIES +
      `?pageSize=10000&channelName=${channelName}&asOfDate=${dateOfService}&materialType=${materialType}&visionType=${visionType}`;
    return this.callLensCatalog(url);
  }

  getLensDetail(spectacleLensId: string, dateOfService: string) {
    const url = this.LENS_DETAIL + '/' + spectacleLensId + `?asOfDate=${dateOfService}`;
    return this.callLensCatalogDetail(url);
  }

  private callLensCatalog(type: string) {
    const httpHeaders = this.getHttpHeaders();
    const httpParams = this.getHttpParams(type);
    return this.http.get<LensMaterialReferenceType[]>(this.lensCatalogApiEndpoint + type, {'headers': httpHeaders, 'params': httpParams})
      .catch((error: any) => {
        console.error('Error getting ' + this.lensCatalogApiEndpoint + type + ' - ' + error.statusText);
        return Observable.throw(error);
      });
  }
  // Calling Lens Catalog api to get lens detail and return the right data type LensCatalogReferenceType
  private callLensCatalogDetail(type: string) {
    const httpHeaders = this.getHttpHeaders();
    const httpParams = this.getHttpParams(type);
    return this.http.get<LensCatalogReferenceType>(this.lensCatalogApiEndpoint + type, {'headers': httpHeaders, 'params': httpParams})
      .catch((error: any) => {
        console.error('Error getting ' + this.lensCatalogApiEndpoint + type + ' - ' + error.statusText);
        return Observable.throw(error);
      });
  }

  public getHttpHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('Authorization', TokenManager.token.toString())
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json');
  }

  public getHttpParams(type: string): HttpParams {
    const params = new HttpParams();
    switch (type) {
      case 'AR_COATINGS':
      case 'SCRATCH_COATINGS':
      case 'UV_COATINGS':
      case 'MIRROR_SKI_COATINGS':
      case 'GLASS_COATINGS':
        params.set('includeactive', 'false');
        break;
      default:
    }
    return params;
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/lens-catalog-api.service.ts